import { StandardTabs } from '@dreryk/react-components';

import { VisitHistoryWithConfidentialDetails } from '~libs.shared.visit';

import { visitHistoryTranslationKeys } from '../translations';

import { VisitHistoryElectronicReferralsTable } from './VisitHistoryElectronicReferralsTable';
import { VisitHistoryMedicalDocumentsTable } from './VisitHistoryMedicalDocumentsTable';
import { VisitHistoryMedicalLeavesTable } from './VisitHistoryMedicalLeavesTable';
import { VisitHistoryPrescriptionsTable } from './VisitHistoryPrescriptionsTable';
import { ElectronicDocumentsTable } from './electronicDocumentsTable/ElectronicDocumentsTable';
import { PatientConsentsTable } from './patientConsentsTable/PatientConsentsTable';

type VisitHistoryDocumentTabsProps = {
   readonly visitHistory: VisitHistoryWithConfidentialDetails;
   readonly patientId: number;
};

export const VisitHistoryDocumentTabs = (props: VisitHistoryDocumentTabsProps): JSX.Element => {
   const { confidentialDetails } = props.visitHistory;
   return (
      <StandardTabs testId={'documents'}>
         <StandardTabs.Tab
            id={'prescriptions'}
            testId={'prescriptions'}
            label={visitHistoryTranslationKeys.documentTabs.prescriptions}
            count={confidentialDetails.prescriptionCount}
         >
            <VisitHistoryPrescriptionsTable prescriptions={confidentialDetails.prescriptions} />
         </StandardTabs.Tab>

         <StandardTabs.Tab
            id={'electronicReferrals'}
            testId={'electronicReferrals'}
            label={visitHistoryTranslationKeys.documentTabs.electronicReferrals}
            count={confidentialDetails.electronicReferralCount}
         >
            <VisitHistoryElectronicReferralsTable visitId={props.visitHistory.id} />
         </StandardTabs.Tab>

         <StandardTabs.Tab
            id={'electronicDocuments'}
            testId={'electronicDocuments'}
            label={visitHistoryTranslationKeys.documentTabs.electronicDocuments}
            count={confidentialDetails.edmCount}
         >
            <ElectronicDocumentsTable visitId={props.visitHistory.id} />
         </StandardTabs.Tab>

         <StandardTabs.Tab
            id={'medicalLeaves'}
            testId={'medicalLeaves'}
            label={visitHistoryTranslationKeys.documentTabs.medicalLeaves}
            count={confidentialDetails.medicalLeaveCount}
         >
            <VisitHistoryMedicalLeavesTable visitId={props.visitHistory.id} />
         </StandardTabs.Tab>

         <StandardTabs.Tab
            id={'medicalDocuments'}
            testId={'medicalDocuments'}
            label={visitHistoryTranslationKeys.documentTabs.medicalDocuments}
            count={confidentialDetails.medicalDocumentCount}
         >
            <VisitHistoryMedicalDocumentsTable visitId={props.visitHistory.id} />
         </StandardTabs.Tab>

         <StandardTabs.Tab
            id={'patientConsents'}
            testId={'patientConsents'}
            label={visitHistoryTranslationKeys.documentTabs.patientConsents}
            count={confidentialDetails.patientConsentCount}
         >
            <PatientConsentsTable visitId={props.visitHistory.id} patientId={props.patientId} />
         </StandardTabs.Tab>
      </StandardTabs>
   );
};
